export const adminAccountPasswordRegexp = new RegExp('^.{8,}$');
